import React, { useEffect, useState } from "react";
import { AppBar, Toolbar, Container, Slide, Grid } from "@material-ui/core";

import {
  createStyles,
  makeStyles,
  Theme,
  useTheme,
  WithStyles,
} from "@material-ui/core/styles";
import CompanyName from "../../../components/HeaderComponents/GeneralMenu/CompanyName";
import MoCompanyName from "./MoCompanyName";
// import useScrollTrigger from "@material-ui/core/useScrollTrigger";

interface GeneralMenuProps extends WithStyles<typeof styles> {
  children?: React.ReactNode;
  className?: string;
}

const styles = {
  groot: {},
};

const useStyles = makeStyles((theme: Theme) => createStyles({}));

function MobileMenu(topState: any) {
  const theme = useTheme();

  return (
    <Toolbar style={{ padding: 0 }}>
      <Grid item container xs={12}>
        <Grid item xs={12}>
          {/* <CompanyName topState={topState} /> */}
          <MoCompanyName />
        </Grid>
        {/* <Grid xs={7} item container> */}
          {/* <MenuSection topState={topState} /> */}
        {/* </Grid> */}
      </Grid>
    </Toolbar>
  );
}

export default MobileMenu;
